import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { Clock, Users, Building } from 'lucide-react';
import type { EventStats, ProfileEvent } from './types';
import { formatDuration } from '@/utils/volunteerHours';

interface EventPreviewStatsProps {
  stats: EventStats;
  currentEvent: ProfileEvent | null;
  loading: boolean;
}

export function EventPreviewStatsDesktop({ stats, currentEvent, loading }: EventPreviewStatsProps) {
  return (
    <Grid
      display={{ base: 'none', md: 'grid' }}
      templateColumns="repeat(3, 1fr)"
      gap="4"
    >
      {loading ? (
        <>
          <Box h="96px" bg="volyx.lightGray" borderRadius="xl" className="animate-pulse" />
          <Box h="96px" bg="volyx.lightGray" borderRadius="xl" className="animate-pulse" />
          <Box h="96px" bg="volyx.lightGray" borderRadius="xl" className="animate-pulse" />
        </>
      ) : (
        <>
          <Flex direction="column" align="center" p="4" bg="volyx.lightGray" borderRadius="xl">
            <Box as={Users} boxSize="24px" color="volyx.primary" mb="2" />
            <Text fontSize="2xl" fontWeight="bold" color="volyx.text">{stats.totalVolunteers}</Text>
            <Text fontSize="sm" color="volyx.textSecondary" mt="1">Volunteers</Text>
          </Flex>
          <Flex direction="column" align="center" p="4" bg="volyx.lightGray" borderRadius="xl">
            <Box as={Clock} boxSize="24px" color="volyx.primary" mb="2" />
            <Text fontSize="2xl" fontWeight="bold" color="volyx.text">{formatDuration(stats.totalHours)}</Text>
            <Text fontSize="sm" color="volyx.textSecondary" mt="1">Hours</Text>
          </Flex>
          <Flex direction="column" align="center" p="4" bg="volyx.lightGray" borderRadius="xl">
            <Box as={Building} boxSize="24px" color="volyx.primary" mb="2" />
            <Text fontSize="2xl" fontWeight="bold" color="volyx.text">
              {stats.filledSlots}/{currentEvent?.slots ?? 0}
            </Text>
            <Text fontSize="sm" color="volyx.textSecondary" mt="1">Slots</Text>
          </Flex>
        </>
      )}
    </Grid>
  );
}

export function EventPreviewStatsMobile({ stats, currentEvent, loading }: EventPreviewStatsProps) {
  return (
    <Flex
      justify="space-around"
      px="5"
      mb="6"
      display={{ base: 'flex', md: 'none' }}
    >
      {loading ? (
        <>
          <Box w="20" h="16" bg="volyx.lightGray" borderRadius="xl" className="animate-pulse" />
          <Box w="20" h="16" bg="volyx.lightGray" borderRadius="xl" className="animate-pulse" />
          <Box w="20" h="16" bg="volyx.lightGray" borderRadius="xl" className="animate-pulse" />
        </>
      ) : (
        <>
          <Flex direction="column" align="center" flex="1">
            <Box as={Users} boxSize="20px" color="volyx.primary" mb="1" />
            <Text fontSize="xl" fontWeight="bold" color="volyx.text">{stats.totalVolunteers}</Text>
            <Text fontSize="xs" color="volyx.textSecondary" mt="0.5">Volunteers</Text>
          </Flex>
          <Flex direction="column" align="center" flex="1">
            <Box as={Clock} boxSize="20px" color="volyx.primary" mb="1" />
            <Text fontSize="xl" fontWeight="bold" color="volyx.text">{formatDuration(stats.totalHours)}</Text>
            <Text fontSize="xs" color="volyx.textSecondary" mt="0.5">Hours</Text>
          </Flex>
          <Flex direction="column" align="center" flex="1">
            <Box as={Building} boxSize="20px" color="volyx.primary" mb="1" />
            <Text fontSize="xl" fontWeight="bold" color="volyx.text">
              {stats.filledSlots}/{currentEvent?.slots ?? 0}
            </Text>
            <Text fontSize="xs" color="volyx.textSecondary" mt="0.5">Slots</Text>
          </Flex>
        </>
      )}
    </Flex>
  );
}
